<template>
  <div class="flex">
    <div class="relative">
      <div
        class="border-static-default-low rounded-sm flex h-40 w-40 items-center justify-center border"
      >
        <RevIllustration
          alt=""
          class="h-32 w-32"
          :height="32"
          :src="imageUrl"
          :width="32"
        />
      </div>
    </div>

    <div class="ml-24 w-full">
      <div class="space-y-8">
        <div class="flex justify-between gap-24">
          <h2 class="body-2-bold" data-qa="product-name">
            {{ i18n(translations.giftCardItem, { price: i18n.price(price) }) }}
          </h2>
          <div class="body-2" data-qa="product-price">
            {{ i18n.price(price) }}
          </div>
        </div>

        <div class="body-2">
          {{ i18n(translations.emailDelivery) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Price } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './GiftCardItem.translations'

const i18n = useI18n()

defineProps<{
  price: Price
  imageUrl: string
}>()
</script>
